import { useMemo } from 'react';

import { useNavigate } from 'react-router-dom';
import { ActionIcon, Card, ScrollArea, Stack, Text } from 'ui';
import { useElementSize } from 'ui/Hooks';
import { IconChevronLeft } from 'ui/Icons';

import { YourPersonalizedStartContent } from '../../components/organisms/onboarding/modals/YourPersonalizedStart/YourPersonalizedStart';

const YourPersonalizedStart = () => {
  const navigate = useNavigate();
  const { ref, height } = useElementSize();
  const { ref: titleRef, height: titleHeight } = useElementSize();

  const maxCardHeight = useMemo(() => {
    if (!titleHeight || !height) {
      return undefined;
    }
    return height - titleHeight;
  }, [height, titleHeight]);

  return (
    <Stack
      ref={ref}
      mah={'calc(100vh - var(--safe-area-top))'}
      style={{ flexGrow: 1, height: '100%' }}
      gap="0"
    >
      <Stack ref={titleRef} gap="xs" p="lg">
        <ActionIcon
          color="white"
          size="lg"
          onClick={() => navigate('/home')}
          variant="transparent"
          mb="4"
        >
          <IconChevronLeft />
        </ActionIcon>
        <Text fz="26" c="white" fw={600}>
          Your Personalized Start
        </Text>
        <Text c="white" fz="16" fw={500}>
          Start with a few simple steps picked just for you.
        </Text>
      </Stack>

      <Card p="lg" style={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0, flex: 1 }}>
        <ScrollArea.Autosize mah={maxCardHeight}>
          <YourPersonalizedStartContent />
        </ScrollArea.Autosize>
      </Card>
    </Stack>
  );
};

export { YourPersonalizedStart };
